import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	header: 'We need the following information to get you the best rate',
	currencyHeader: 'What currency to send',
	dateHeader: 'When to send it',
	amountHeader: 'How much to send',
	feesHeader: 'Who is paying the fees',
	rateHeader: 'Exchange rate',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
